import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
class Hidable {
  constructor(component) {
    this.component = component;
  }
  isHidden() {
    return this.component.classList.contains('--hidden');
  }
  setHidden(isHidden) {
    var _this$component$contr;
    if (this.namespace) iamotaEventHandler.trigger("".concat(this.namespace, ":hiding"), {
      component: this
    }, {
      context: this
    });
    this.component.classList.toggle('--hidden', isHidden);
    this.component.setAttribute('aria-hidden', isHidden);
    (_this$component$contr = this.component.controls) === null || _this$component$contr === void 0 || _this$component$contr.forEach(control => {
      control.classList.toggle('--hidden', isHidden);
      control.setAttribute('aria-hidden', isHidden);
    });
    if (this.namespace) iamotaEventHandler.trigger("".concat(this.namespace, ":hidden"), {
      component: this
    }, {
      context: this
    });
  }
  hide() {
    this.setHidden(true);
  }
  show() {
    this.setHidden(false);
  }
}
export default Hidable;